import { InputText } from "primereact/inputtext";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { REGEX_EMAIL } from "src/core/validation/validation";

export interface EmailFormData extends FieldValues {
  email: string;
}

type EmailProps<T extends EmailFormData> = {
  form: UseFormReturn<T, any, T>;
  required: boolean;
  disabled?: boolean;
  errorField?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};

export function EmailField<T extends EmailFormData>({
  form,
  required,
  disabled,
  errorField,
  onKeyDown,
}: EmailProps<T>) {
  const { t } = useTranslation();

  const error = form.formState.errors.email as Record<string, any> | undefined;

  return (
    <>
      <InputText
        id="email"
        autoComplete="email"
        className="w100"
        disabled={disabled}
        invalid={!!error}
        type="email"
        {...form.register("email" as Path<T>, {
          required: required && t("Error.Required"),
          pattern: {
            value: REGEX_EMAIL,
            message: t("Error.Pattern"),
          },
        })}
        onKeyDown={onKeyDown}
      />
      {(errorField ?? true) && error && (
        <small className="p-error block">{error?.message}</small>
      )}
    </>
  );
}
